import { render, staticRenderFns } from "./ExpirationPeriod.vue?vue&type=template&id=ef01a4e0&scoped=true&"
import script from "./ExpirationPeriod.vue?vue&type=script&lang=js&"
export * from "./ExpirationPeriod.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationPeriod.vue?vue&type=style&index=0&id=ef01a4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef01a4e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef01a4e0')) {
      api.createRecord('ef01a4e0', component.options)
    } else {
      api.reload('ef01a4e0', component.options)
    }
    module.hot.accept("./ExpirationPeriod.vue?vue&type=template&id=ef01a4e0&scoped=true&", function () {
      api.rerender('ef01a4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/expiration-campaign/components/ExpirationPeriod.vue"
export default component.exports